<template>
	<div class="body">
		<div class="main">
			<div class="main_item">
				<h3>企业服务</h3>
				<div class="main_item_child">
					<!-- <div>
						<p @click="goto('XybgSearch')">信用报告查询</p>
					</div> -->
					<div>
						<p class="" @click="goto('FirmmsgSearch')">中小企业信息查询</p>
					</div>
					<div>
						<p @click="goto('CheckName')">重名查询</p>
					</div>
					<div>
						<p @click="goto('chuangwenIndex')">创文助手</p>
					</div>		
					<div>
						<p @click="goto('yaoguanIndex')">四类药零售检测预警系统</p>
					</div>	
					<div>
						<p @click="gotoyima('yiyeyima')">一业一证</p>
					</div>

					<!-- <div>
						<p @click="goto('rencailogin')">东楚人才</p>
					</div>
					<div class="yinying">					
						<p @click="goto1()">跳转小程序</p>
					</div> -->
					
					<!-- <div>
						<p @click="goto('yaoguanAddtwo')">药品管控2</p>
					</div>	
					<div>
						<p @click="goto('yaoguanAddThree')">药品管控3</p>
					</div> -->	
			</div>
			</div>	
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				inputcode:123456
			}
		},
		created() {
			this.test()
			//this.getList()
			console.log(this.$router)
		},
		methods: {
			goto1(){
				location.href="weixin://dl/business/?t=qOet8IKvMLf"
			},
			gotoyima(url){
				// this.$router.push(url)
				// console.log('url',url)
				let that = this
				this.$router.push(url)
				// AlipayJSBridge.call('scan', {
				// 	type: 'bar',
				// 	actionType: 'scanAndRoute'
				// }, function(result) {
				// 	console.log(result.qrCode)
				// 	that.$router.push({
				// 		path: '/'+url,
				// 		query: {
				// 			code:result.qrCode
				// 		}
				// 	})
				// });
			},
			goto(url) {
				this.$router.push(url)
			},
			test() {
				this.checkAJB.getUserInfo()
				
			},
			getList() {
				console.log("getList", this);
				this.request({
						url: `/smartagriarea/queryAgriPoliciesInfo`,
						type: "post",
						params: {
							currentPage: 1,
							infoType: "4",
							pageSize: 10
						},
					})
					.then((res) => {
						console.log('res1’', res);
					})
					.catch((err) => {
						console.log('res2’', err);
					})
			}
		}
	};
</script>
<style lang="less" scoped>
	.body {
		padding: 10px;
	}
	.main{
		background-color: white;
		padding: 0 5px;
	}
	.main_item h3 {
		font-size: 20px;
		font-weight: 600;
		padding: 10px 0;;
	}

	.main_item_child {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px 0;;
		flex-wrap: wrap;
		
	}
	.main_item_child div{
		padding:0 10px
	}
	.yinying{
		width: 100px;
		height: 50px;
		line-height: 50px;
	}
	/* From uiverse.io by @alexruix */
	.group {
	 display: flex;
	 line-height: 28px;
	 align-items: center;
	 position: relative;
	 max-width: 190px;
	}
	
	.input {
	 width: 100%;
	 height: 40px;
	 line-height: 28px;
	 padding: 0 10px;
	 padding-left: 25px;
	 border: 2px solid transparent;
	 border-radius: 8px;
	 outline: none;
	 background-color: #f3f3f4;
	 color: #0d0c22;
	 transition: .3s ease;
	}
	
	.input::placeholder {
	 color: #9e9ea7;
	}
	
	.input:focus, input:hover {
	 outline: none;
	 border-color: rgba(234,76,137,0.4);
	 background-color: #fff;
	 box-shadow: 0 0 0 4px rgb(234 76 137 / 10%);
	}
	
	.icon {
	 position: absolute;
	 left: 10px;
	 fill: #9e9ea7;
	 width: 10px;
	 height: 10px;
	}
	
	/* From uiverse.io by @mobinkakei */
	.switch-holder {
	  display: flex;
	  padding: 10px 20px;
	  border-radius: 10px;
	  box-shadow: -8px -8px 15px rgba(255, 255, 255, .7),
	        10px 10px 10px rgba(0, 0, 0, .2),
	        inset 8px 8px 15px rgba(255, 255, 255, .7),
	        inset 10px 10px 10px rgba(0, 0, 0, .2);
	  justify-content: space-between;
	  align-items: center;
	}
	
	.switch-label {
	  padding: 0 20px 0 10px
	}
	
	.switch-label i {
	  margin-right: 5px;
	}
	
	.switch-toggle {
	  height: 40px;
	}
	
	.switch-toggle input[type="checkbox"] {
	  position: absolute;
	  opacity: 0;
	  z-index: -2;
	}
	
	.switch-toggle input[type="checkbox"]+label {
	  position: relative;
	  display: inline-block;
	  width: 100px;
	  height: 40px;
	  border-radius: 20px;
	  margin: 0;
	  cursor: pointer;
	  box-shadow: inset -8px -8px 15px rgba(255, 255, 255, .6),
	        inset 10px 10px 10px rgba(0, 0, 0, .25);
	}
	
	.switch-toggle input[type="checkbox"]+label::before {
	  position: absolute;
	  content: 'OFF';
	  font-size: 13px;
	  text-align: center;
	  line-height: 25px;
	  top: 8px;
	  left: 8px;
	  width: 45px;
	  height: 25px;
	  border-radius: 20px;
	  background-color: #eeeeee;
	  box-shadow: -3px -3px 5px rgba(255, 255, 255, .5),
	        3px 3px 5px rgba(0, 0, 0, .25);
	  transition: .3s ease-in-out;
	}
	
	.switch-toggle input[type="checkbox"]:checked+label::before {
	  left: 50%;
	  content: 'ON';
	  color: #fff;
	  background-color: #00b33c;
	  box-shadow: -3px -3px 5px rgba(255, 255, 255, .5),
	        3px 3px 5px #00b33c;
	}
</style>
